import {
  Dialog,
  DialogBody,
  DialogCancel,
  DialogFooter,
  DialogHeader,
} from 'client/components/core/Dialog'
import { AutomationRuleActionsEnum } from 'client/enums/AutomationRulesEnum'
import { useManagement } from 'client/store'
import managementSelectors from 'client/store/management/managementSelectors'
import { ActionEditType } from 'client/types/AutomationRulesActionsEditInterface'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import ActionModalHeaderUi from './ui/ActionModalHeaderUi'
import {
  ActionItem,
  actionItems,
  getDefaultActionValue,
} from './utils/automationRuleUtils'

interface AddActionModalProps {
  opened: boolean
  onClose: () => void
  setRules: React.Dispatch<React.SetStateAction<ActionEditType[]>>
  maxActionId: React.MutableRefObject<number>
}

function AddActionModal({
  opened,
  onClose,
  setRules,
  maxActionId,
}: AddActionModalProps) {
  const { t } = useTranslation()
  const userId = useManagement(managementSelectors.getUserId)

  const isActionAvailableFilter = useCallback(
    (action: ActionItem) => {
      if (!userId) {
        return false
      }

      // for now create user will be available only for Aurelien, because we don't have workspace information in editor
      const isRootAdmin = userId === 161
      if (!isRootAdmin) {
        return action.slug !== AutomationRuleActionsEnum.create_user
      } else {
        return true
      }
    },
    [userId],
  )

  return (
    <Dialog width={900} show={opened}>
      <DialogHeader grayHeader={false} close={onClose}>
        <ActionModalHeaderUi>
          {t('entity_settings.automation_rule.edit.add_action')}
        </ActionModalHeaderUi>
      </DialogHeader>
      <DialogBody>
        <div className="flex flex-col gap-5 px-10">
          {actionItems
            .filter(isActionAvailableFilter)

            .map(action => (
              <button
                key={`add-action:${action.slug}`}
                className="group flex cursor-pointer items-center gap-3 border-textSecondary/30 pb-5 text-left [&:not(:last-of-type)]:border-b"
                type="button"
                onClick={() => {
                  setRules(prev => {
                    return [
                      ...prev,
                      {
                        ...getDefaultActionValue(action.slug, maxActionId),
                      },
                    ]
                  })
                  onClose()
                }}
              >
                <div className="h-10 w-10 [&>svg]:h-10 [&>svg]:w-10 [&>svg]:transition-colors [&>svg]:group-hover:fill-iconPrimary">
                  {action.icon}
                </div>
                <div className="flex flex-col gap-1">
                  <span className="font-bold text-[15px] text-textPrimary">
                    {t(action.title)}
                  </span>
                  <span className="text-M text-textTertiary">
                    {t(action.description)}
                  </span>
                </div>
              </button>
            ))}
        </div>
      </DialogBody>
      <DialogFooter>
        <DialogCancel onClick={onClose}>
          {t('entity_settings.survey.back_to_list')}
        </DialogCancel>
      </DialogFooter>
    </Dialog>
  )
}

export default AddActionModal
